var exports = {
  "i": "wrapper__jvwkNc",
  "j": "connectedDot__gfDgXa",
};

module.exports = exports;
